import React from 'react';
import { useParams } from 'react-router-dom';
import { NavBar } from '../../../ui/NavBar/NavBar';
import { JobPostDetails } from './JobPostDetails';
import JobPostTable from './JobPostTable';

export const JobPostingView = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <div className='bg-gray-100 min-h-screen'>
      <NavBar variant='job_posting' />
      <div className='pt-[var(--nav-height,3.5rem)]'>
        { id ? (
          <div className='flex w-full justify-center'>
            <JobPostDetails />
          </div>
        ) : (
          <JobPostTable />
        ) }
      </div>
    </div>
  );
};
